import React, { useId } from 'react';

// Brand-gradient "+" used by the dashed Add buttons (Deal Flow pipeline/status tabs,
// board view). useId keeps the gradient + clipPath ids unique per instance, so the
// several Add buttons on one page can't collide.
const PlusGradientIcon = ({ size = 12, style = {} }) => {
  const id = useId();
  const g0 = `plus_g0_${id}`;
  const g1 = `plus_g1_${id}`;
  const clip = `plus_clip_${id}`;

  const stops = (
    <>
      <stop stopColor="#7852F8" />
      <stop offset="1" stopColor="#84AEF6" />
    </>
  );

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block', ...style }}
    >
      <g clipPath={`url(#${clip})`}>
        <rect y="5" width="12" height="2" rx="1" fill={`url(#${g0})`} />
        <rect x="5" width="2" height="12" rx="1" fill={`url(#${g1})`} />
      </g>
      <defs>
        <linearGradient id={g0} x1="-3" y1="5.5" x2="-2.35135" y2="9.39189" gradientUnits="userSpaceOnUse">{stops}</linearGradient>
        <linearGradient id={g1} x1="4.5" y1="3" x2="8.39189" y2="3.64865" gradientUnits="userSpaceOnUse">{stops}</linearGradient>
        <clipPath id={clip}>
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PlusGradientIcon;
